export const COMPARE_ENABLED_CONFIG = 'Newbuilding.ComparisonOfferCardEntrypoints.Enabled';
export const COMPARE_BUTTON_DATA_MARK = 'NewbuildingCompareButton';
export const ADD_TO_COMPARE_LABEL = 'Добавить к сравнению';
export const REMOVE_FROM_COMPARE_LABEL = 'Удалить из сравнения';
export const ADD_TO_COMPARE_TEXT = 'Сравнить ЖК';
export const REMOVE_FROM_COMPARE_TEXT = 'В сравнении';
